import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Assessments list (CLAUDE.md §2.3),
 * mirroring the CRM/HRM list stores. Search/course/active filters live in
 * URL-bound page state and stay out of the store — those are server-driven
 * query params, not durable user prefs.
 */
export type AssessmentsViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const ASSESSMENTS_VIEW_MODES: AssessmentsViewMode[] = [
  'table',
  'list',
  'cards',
  'grouped',
];

interface AssessmentsUiState {
  view: AssessmentsViewMode;
  setView: (view: AssessmentsViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-created`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useAssessmentsUi = create<AssessmentsUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'lms.assessments:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
